import SEGMENT_TYPES from '../../scripts/constants/segment-types-enum';
import PaidSegmentChoiceUIModel from './paid-segment-choice';
import SegmentChoiceUIModel from './segment-choice';
import TicketedSegmentChoiceUIModel from './ticketed-segment-choice';

class SegmentChoiceCollectionUIModel {
  constructor(obj) {
    this.hasSomeUnpaidSeat = false;
    this.items = [];
    this.hasSomeTicketedSeat = false;
    this.hasSomeTicketedSeatPP = false;

    if (obj !== null) {
      let item = null;
      this.hasSomeUnpaidSeat = obj && obj._collection.some(segmentChoice => {
        if (segmentChoice) {
          const {
            seat,
            seatSelectionFee,
          } = segmentChoice;
          const totalCurrency = seat?.currency?.total;
          return (totalCurrency !== 0 && totalCurrency !== undefined) || seatSelectionFee;
        } else {
          return false;
        }
      });

      this.items = obj._collection.map(segmentChoice => {
        if (segmentChoice._meta.class === SEGMENT_TYPES.SEGMENT_CHOICE) {
          item = new SegmentChoiceUIModel(segmentChoice);
        }
        if (segmentChoice._meta.class === SEGMENT_TYPES.PAID_SEGMENT_CHOICE) {
          item = new PaidSegmentChoiceUIModel(segmentChoice);
        }
        if (segmentChoice._meta.class === SEGMENT_TYPES.TICKETED_SEGMENT_CHOICE) {
          if (segmentChoice.redeemedCP)
            this. hasSomeTicketedSeatPP = true;
          else
            this.hasSomeTicketedSeat = true;
          item = new TicketedSegmentChoiceUIModel(segmentChoice);
        }
        return item;
      });
    }
  }

  /*
   * @param index
   * @return SegmentChoice for position
  */
  getSegmentChoice(index) {
    return this.items[index];
  }

  /*
   * @param segmentCode
   * @return SegmentChoice for segmentCode
  */
  getSegmentChoiceBySegment(code) {
    const segmentsChoice = this.items.filter((segmentChoice) => {
      return segmentChoice.segmentCode === code;
    });
    return segmentsChoice.length > 0 ? segmentsChoice[0] : null;
  }

  /*
   * @param segmentCode
   * @return SegmentChoice for segmentCode
  */
  getSegmentChoiceBySegmentCode(code) {
    let position = 0;
    const segmentsChoice = this.items.filter((segmentChoice, index) => {
      if (segmentChoice.segmentCode === code) {
        position = index;
      }
      return segmentChoice.segmentCode === code;
    });
    return segmentsChoice.length > 0 ? { 'segmentChoice': segmentsChoice[0], 'index': position } : null;
  }

  getAllUnPaidSegmentChoice(isOnHold = false) {
    return this.items.filter(segmentChoice => {
      return isOnHold ? isOnHold : !segmentChoice.isPaid;
    });
  }

  getAllPaidSegmentChoice(isOnHold = false) {
    return this.items.filter(segmentChoice => {
      return isOnHold ? isOnHold : segmentChoice.isPaid;
    });
  }

  getUnPaidSegmentChoice(segments) {
    const segmentChoiceBySegment = {};
    segments.forEach(segment => {
      const segmentChoice = this.getSegmentChoiceBySegment(segment);
      segmentChoiceBySegment[segment] = segmentChoice && !segmentChoice.isPaid && segmentChoice.getTotal()
        ? this.getSegmentChoiceBySegment(segment) : null;
    });
    return segmentChoiceBySegment;
  }

  getTicketedSegmentChoice(segments) {
    const segmentChoiceBySegment = {};
    segments.forEach(segment => {
      const segmentChoice = this.getSegmentChoiceBySegment(segment);
      segmentChoiceBySegment[segment] = segmentChoice !== null ? segmentChoice.hasOwnProperty('emd') ? this.getSegmentChoiceBySegment(segment) : null : null;
    });
    return segmentChoiceBySegment;
  }

  orderSegmentChoicesBySegments(segments) {
    const segmentChoicesOrder = [];
    segments.forEach(segment => {
      const segmentChoice = this.getSegmentChoiceBySegment(segment.segmentCode);
      if (segmentChoice) {
        segmentChoicesOrder.push(segmentChoice);
      }
    });
    return segmentChoicesOrder.length > 0 ? segmentChoicesOrder : null;
  }

  toApi() {
    return this.items.map(segmentChoice => {
      return segmentChoice.toApi();
    });
  }
}

export default SegmentChoiceCollectionUIModel;
